import {
  Radio,
  DatePicker,
  Select,
  Button,
  Input,
  Modal,
  message,
  Upload,
  Spin,
  ConfigProvider,
} from "antd";
import { InboxOutlined } from "@ant-design/icons";
import "./index.styl";
import { useCallback, useEffect, useRef, useState } from "react";
import { getServerTimeOptions, sortByChinese } from "../../../utils/smartBeans";
import {
  getMainModuleList,
  getChildModuleList,
  getRoleList,
} from "../../../api/common";
import {
  addSmartBeansReq,
  reduceSmartBeansReq,
  uploadSmartBeansByExel,
} from "../../../api/smartBeans";
import locale from "antd/locale/zh_CN";
import "dayjs/locale/zh-cn";
import { resetLoginInfo } from "../../../utils/common";
import { getStorageValByKey, STORAGE_KEY } from "../../../utils/storage";
import { getStudentInfoList } from "../../../api/studentInfo";
import {
  BASE_URL,
  SMART_BEANS_UPLOAD_TEMPLATE_URL,
} from "../../../utils/request";

const { Dragger } = Upload;

export default function SmartBeansInput() {
  const [batchAction, setBatchAction] = useState(2);
  const [showComfirmModal, setShowComfirmModal] = useState(false);
  const [isAddSmartBeans, setIsAddSmartBeans] = useState(true);

  const [mainModuleData, setMainModuleData] = useState([]);
  const [defaultMainModuleKey, setDefaultMainModuleKey] = useState("");

  const [childModuleData, setChildModuleData] = useState([]);
  const [defaultChildModuleKey, setDefaultChildModuleKey] = useState("");
  const [roleData, setRoleData] = useState([]);
  const [defaultRoleKey, setDefaultRoleKey] = useState("");
  const [defaultRoleBeans, setDefaultRoleBeans] = useState(null);

  const [showCountrySelect, setShowCountrySelect] = useState(false);
  const [countrysideData, setCountrysideData] = useState([]);
  const [defaultCountrysideKey, setDefaultCountrysideKey] = useState("");

  const [showErrorModel, setShowErrorModel] = useState(false);
  const errorInfo = useRef([]);

  const [inputNickName, setInputNickName] = useState("");

  const mainSelectedItem = useRef({});
  const childSelectedItem = useRef({});
  const roleSelectedItem = useRef({});
  const serverTimes = useRef(0);
  const fileUrl = useRef("");
  const isLoading = useRef(false);

  const [smartBeanAction, setSmartBeanAction] = useState(1);

  const [uploadFileList, setUploadFileList] = useState([]);

  const updateSmartBeansByExel = useCallback(async () => {
    if (!fileUrl.current) {
      message.warning("请先上传文件！");
      return;
    }
    const res = await uploadSmartBeansByExel({
      excel_url: fileUrl.current,
      type: smartBeanAction,
      applicant: getStorageValByKey(STORAGE_KEY.userNo) || "",
    });

    if (res.code == 0 && res.data?.length < 1) {
      message.success("批量导入成功！");
    } else {
      errorInfo.current = res.data;
      setShowErrorModel(true);
      message.error("批量导入失败！");
    }

    fileUrl.current = "";
    setUploadFileList([]);
  }, [smartBeanAction]);

  const onSmartBeanActionChanged = useCallback((e) => {
    setSmartBeanAction(e.target.value);
  }, []);

  const props = {
    // fileList: uploadFileList,
    headers: {
      Authorization: `Bearer ${getStorageValByKey(STORAGE_KEY.token)}`,
    },
    name: "file",
    maxCount: 1,
    multiple: false,
    action: `${BASE_URL}/common/file/upload`,
    onChange(info) {
      const { status, response } = info.file;
      if (status === "uploading" && !isLoading.current) {
        isLoading.current = true;
        message?.loading(
          {
            content: "",
            icon: <Spin tip="文件上传中..." />,
            style: { padding: 0 },
            // className: "loading",
          },
          [12]
        );
      }
      console.log("status:", status);
      if (status === "done") {
        if (response.code == 0 && response.data > "") {
          fileUrl.current = response.data;
          setUploadFileList([response.data]);
        }
        message.destroy();
        isLoading.current = false;
      } else if (status === "error") {
        message.error(`${info.file.name} 批量导入失败！`);
        message.destroy();
        isLoading.current = false;
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  // 主模块数据
  useEffect(() => {
    async function fetchMainModuleList() {
      const res = await getMainModuleList();
      if (res?.code == 0 && res?.data?.length > 0) {
        const mainModuleList = res.data;
        setMainModuleData(mainModuleList);
        setDefaultMainModuleKey(mainModuleList[0].id);
        onMainModuleItemSelected(mainModuleList[0].id);
        mainSelectedItem.current = mainModuleList[0];
      }
      console.log(res);
    }
    fetchMainModuleList();
  }, []);

  // reset录入数据
  const resetInputData = useCallback(() => {
    setMonthData("");
    setBjAccount("");
    setBeansState("");
    setReasonState("");
    setServerTimesState("");
    setDefaultMainModuleKey("");
    setDefaultChildModuleKey("");
    setDefaultRoleKey("");
    setDefaultRoleBeans(null);
    setDefaultCountrysideKey("");
  }, []);

  // 批量操作
  // month
  const [batchMonth, setBatchMonth] = useState("");
  const onbatchMonthChanged = useCallback((date, dateString) => {
    console.log(date, dateString);
    setBatchMonth(dateString);
  }, []);

  // 非批量操作
  // 月份
  const month = useRef("");
  const [monthData, setMonthData] = useState("");
  const onMonthChanged = useCallback((date, dateString) => {
    console.log(date, dateString);
    month.current = dateString;
    setMonthData(date);
  }, []);

  // 帐号
  const [bjAccount, setBjAccount] = useState("");
  const accountStr = useRef("");
  const onAccountStrChanged = useCallback((e) => {
    accountStr.current = e.target.value;
    setBjAccount(e.target.value);
  }, []);

  // 智慧豆数量
  const [beansState, setBeansState] = useState("");
  const beans = useRef(0);
  const onBeansChanged = useCallback((e) => {
    beans.current = e.target.value;
    setBeansState(e.target.value);
  }, []);

  // 增减智慧豆原因
  const [reasonState, setReasonState] = useState("");
  const reason = useRef("");
  const onReasonChanged = useCallback((e) => {
    reason.current = e.target.value;
    setReasonState(e.target.value);
  }, []);

  // 增加智慧豆
  const addSmartBeans = useCallback(async () => {
    console.log("roleSelectedItem.current", roleSelectedItem.current);
    const data = {
      user_no_list: accountStr.current,
      job_time: month.current + "-01 00:00:00",
      job_num: serverTimes.current,
      desc: reason.current,
      bean_amount: beans.current,
      job_id: roleSelectedItem.current.id,
      applicant: getStorageValByKey(STORAGE_KEY.userNo) || "",
    };
    const res = await addSmartBeansReq(data);

    if (res.code == 0) {
      setShowComfirmModal(false);
      message.success("录入成功！");
      resetInputData();
    } else {
      message.error("录入失败！");
    }
  }, []);

  // 消耗智慧豆
  const reduceSmartBeans = useCallback(async () => {
    const data = {
      user_no_list: accountStr.current,
      job_time: month.current + "-01 00:00:00",
      desc: reason.current,
      bean_amount: beans.current,
      applicant: getStorageValByKey(STORAGE_KEY.userNo) || "",
    };
    const res = await reduceSmartBeansReq(data);
    if (res.code == 0) {
      setShowComfirmModal(false);
      message.success("录入成功！");
      resetInputData();
    } else {
      message.error("录入失败！");
    }
  }, []);

  // 选择主模块item
  const onMainModuleItemSelected = useCallback(async (id, option) => {
    mainSelectedItem.current = option;
    setChildModuleData([]);
    setRoleData([]);
    setDefaultChildModuleKey("");
    setDefaultRoleKey("");
    setDefaultRoleBeans(null);
    id && setDefaultMainModuleKey(id);
    if (id > "") {
      const res = await getChildModuleList({ main_depart_id: id });
      if (res.code == 0 && res.data?.length > 0) {
        const childModuleData = res.data;
        setChildModuleData(childModuleData);
        // setDefaultChildModuleKey(childModuleData[0].id);
        // childSelectedItem.current = childModuleData[0];
      }
    }
    setDefaultMainModuleKey(id);
  }, []);

  // 选择子模块item
  const onChildModuleItemSelected = useCallback(async (id, option) => {
    childSelectedItem.current = option;
    setDefaultChildModuleKey(id);
    if (id > "" && id != 11) {
      setShowCountrySelect(false);
      const res = await getRoleList({ depart_id: id });
      if (res.code == 0 && res.data?.length > 0) {
        const roleData = res.data;
        console.log("roledata:", roleData);
        setRoleData(roleData);
        setDefaultRoleKey(roleData[0].id);
        setDefaultRoleBeans(roleData[0].bean_amount);
        roleSelectedItem.current = roleData[0];
      } else {
        setRoleData([]);
        setDefaultRoleKey("");
        setDefaultRoleBeans(null);
      }
    } else if (id == 11) {
      const newCountrysideData = [{ id: "0", name: "全部" }];
      const resC = await getChildModuleList({ main_depart_id: id }); //自然村数据
      if (resC.code == 0 && resC.data?.length > 0) {
        newCountrysideData.push(...resC.data);
      }

      setCountrysideData(sortByChinese(newCountrysideData));
      setDefaultCountrysideKey(newCountrysideData[0].id);
      setShowCountrySelect(true);
      setRoleData([]);
      setDefaultRoleKey("");
      setDefaultRoleBeans(null);
    }
  }, []);

  const onCountrysideItemSelected = useCallback(async (id, option) => {
    setDefaultCountrysideKey(id);
    if (id > "") {
      const res = await getRoleList({ depart_id: id });
      if (res.code == 0 && res.data?.length > 0) {
        const roleData = res.data;
        console.log("roledata:", roleData);
        setRoleData(roleData);
        setDefaultRoleKey(roleData[0].id);
        setDefaultRoleBeans(roleData[0].bean_amount);
        roleSelectedItem.current = roleData[0];
      } else {
        setRoleData([]);
        setDefaultRoleKey("");
        setDefaultRoleBeans(null);
      }
    }
  }, []);

  // 服务次数
  const [serverTimesState, setServerTimesState] = useState("");
  const onServeTimeChanged = useCallback((id, option) => {
    serverTimes.current = id;
    setServerTimesState(id);
  }, []);

  // 选择角色
  const onRoleItemSelected = useCallback((id, option) => {
    roleSelectedItem.current = option;
    console.log("option+_+", option);
    setDefaultRoleKey(id);
    setDefaultRoleBeans(option?.bean_amount);
  }, []);

  const onBatchActionChanged = useCallback((e) => {
    setBatchAction(e.target.value);
  }, []);

  const onIsAddSmartBeansChanged = useCallback((e) => {
    setIsAddSmartBeans(e.target.value);
  }, []);

  const verifySingleInputSmartBeans = useCallback(() => {
    if (isAddSmartBeans) {
      if (!serverTimes.current) {
        message.warning("请选择服务次数！");
        return false;
      }

      if (!roleSelectedItem.current.id) {
        message.warning("请选择角色！");
        return false;
      }
    }

    if (!month.current) {
      message.warning("请选择月份！");
      return false;
    }

    if (!accountStr.current) {
      message.warning("请输入必经学号！");
      return false;
    }

    const regex = /^BJ\d{7}$/;
    const accountArr = accountStr.current?.split(",");
    for (let idx = 0; idx < accountArr.length; idx++) {
      const curAccount = accountArr[idx];
      if (regex.test(curAccount) === false) {
        message.warning("请输入正确的必经学号！");
        return false;
      }
    }

    if (!beans.current) {
      message.warning("请输入智慧豆数量！");
      return false;
    }
    if (beans.current < 1) {
      message.warning("请输入大于0的智慧豆数量！");
      return false;
    }
    if (!reason.current) {
      message.warning("请输入原因！");
      return false;
    }

    return true;
  }, [isAddSmartBeans]);

  // 确认提交
  const onCommit = useCallback(async () => {
    if (isAddSmartBeans) {
      addSmartBeans();
    } else {
      reduceSmartBeans();
    }
  }, [isAddSmartBeans, addSmartBeans, reduceSmartBeans]);

  return (
    <div className="container">
      <div className="btnContainer">
        <Radio.Group onChange={onBatchActionChanged} value={batchAction}>
          <Radio value={1}>批量操作</Radio>
          <Radio value={2}>非批量操作</Radio>
        </Radio.Group>
      </div>
      {batchAction == 1 ? (
        <div className="batchActionContainer" style={{ marginTop: 40 }}>
          {/* <div className="item">
            <span className="itemTitle">选择月份：</span>
            <ConfigProvider locale={locale}>
              <DatePicker
                onChange={onbatchMonthChanged}
                style={{ width: 160 }}
                picker="month"
              />
            </ConfigProvider>
          </div> */}
          <div className="item">
            <span className="itemTitle">智慧豆：</span>
            <Radio.Group
              onChange={onSmartBeanActionChanged}
              value={smartBeanAction}
            >
              <Radio value={1}>增加</Radio>
              <Radio value={2}>减少</Radio>
            </Radio.Group>
          </div>
          <div className="item">
            <span className="itemTitle">选择分类：</span>
            <Select
              defaultValue="0"
              style={{ width: 160 }}
              // onChange={onLearnStatusChanged}
              options={[{ value: "0", label: "福田区打卡任务" }]}
            />
          </div>

          <div className="item">
            <span className="itemTitle">上传文件：</span>
            <Dragger {...props}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                点击或者拖拽文件到区域可以完成上传
              </p>
              <p className="ant-upload-hint">支持模版Excel文件上传</p>
            </Dragger>
            <Button
              style={{ marginTop: 20 }}
              className="searchItem"
              onClick={() => {
                window.location.href = SMART_BEANS_UPLOAD_TEMPLATE_URL;
              }}
              type="link"
            >
              福田区打卡模版
            </Button>
            <Button
              style={{ marginTop: 20 }}
              className="searchItem"
              onClick={() => {
                window.location.href =
                  "https://static.bjzl.net.cn/wisdom-bean/1726931866392-批量扣除智慧豆_模板.xlsx";
              }}
              type="link"
            >
              消耗模版
            </Button>
          </div>
          <div style={{ height: 120 }} />
          <div className="commitBtnContainer">
            {/* <span>文件上传中...</span> */}
          </div>
          <div className="commitBtnContainer">
            <Button
              style={{ marginTop: 20 }}
              className="searchItem"
              type="primary"
              onClick={updateSmartBeansByExel}
            >
              确认提交
            </Button>
          </div>
        </div>
      ) : (
        <div className="batchActionContainer">
          <div className="btnContainer" style={{ marginTop: 30 }}>
            <Radio.Group
              onChange={onIsAddSmartBeansChanged}
              value={isAddSmartBeans}
            >
              <Radio value={true}>增加智慧豆</Radio>
              <Radio value={false}>减少智慧豆</Radio>
            </Radio.Group>
          </div>
          <div className="item">
            <span className="itemTitle">选择月份：</span>
            <ConfigProvider locale={locale}>
              <DatePicker
                value={monthData}
                onChange={onMonthChanged}
                style={{ width: 160 }}
                picker="month"
              />
            </ConfigProvider>
          </div>
          <div className="item">
            <span className="itemTitle">必经之路学号：</span>
            <Input
              value={bjAccount}
              onChange={onAccountStrChanged}
              style={{ height: 32, width: 160 }}
            />
            <span
              style={{
                display: "inline-block",
                marginLeft: 20,
                color: "#999999",
              }}
            >
              (多个学号用,分隔开例如：BJ1234567,BJ1234568)
            </span>
          </div>
          {isAddSmartBeans ? (
            <>
              <div className="item">
                <span className="itemTitle">选择模块：</span>
                <Select
                  value={defaultMainModuleKey}
                  style={{ width: 160 }}
                  onChange={onMainModuleItemSelected}
                  fieldNames={{ label: "name", value: "id" }}
                  options={mainModuleData}
                />
                <span style={{ marginLeft: 20 }} className="itemTitle">
                  选择子模块：
                </span>
                <Select
                  value={defaultChildModuleKey}
                  style={{ width: 160 }}
                  fieldNames={{ label: "name", value: "id" }}
                  onChange={onChildModuleItemSelected}
                  options={childModuleData}
                />
                {showCountrySelect ? (
                  <>
                    <span
                      style={{ width: 80, marginLeft: 20 }}
                      className="itemTitle"
                    >
                      选择村：
                    </span>
                    <Select
                      value={defaultCountrysideKey}
                      style={{ width: 160 }}
                      fieldNames={{ label: "name", value: "id" }}
                      onChange={onCountrysideItemSelected}
                      options={countrysideData}
                    />
                  </>
                ) : null}
              </div>

              <div className="item">
                <span className="itemTitle">选择角色：</span>
                <Select
                  value={defaultRoleKey}
                  style={{ width: 160 }}
                  fieldNames={{ label: "name", value: "id" }}
                  onChange={onRoleItemSelected}
                  options={roleData}
                />
                <span style={{ paddingLeft: 20 }}>
                  {defaultRoleBeans ? `  参考：${defaultRoleBeans}豆/月` : ""}
                </span>
              </div>
              <div className="item">
                <span className="itemTitle">服务次数：</span>
                <Select
                  value={serverTimesState}
                  placeholder="请选择服务次数"
                  style={{ width: 160 }}
                  onChange={onServeTimeChanged}
                  options={getServerTimeOptions()}
                />
              </div>
            </>
          ) : null}
          <div className="item">
            <span className="itemTitle">智慧豆数量：</span>
            <Input
              type="number"
              value={beansState}
              onChange={onBeansChanged}
              placeholder="输入智慧豆数量"
              style={{ height: 32, width: 160, paddingLeft: 10 }}
            />
          </div>
          <div className="item">
            <span className="itemTitle">输入原因：</span>
            <Input.TextArea
              value={reasonState}
              onChange={onReasonChanged}
              style={{ width: 320 }}
              placeholder="请输入原因"
              autoSize={{
                minRows: 3,
                maxRows: 5,
              }}
            />
          </div>

          <div className="commitBtnContainer">
            <Button
              onClick={async () => {
                const res = verifySingleInputSmartBeans();
                if (!res) return;
                console.log("res ver:", res);
                const accountArr = accountStr.current?.split(",");
                if (accountArr.length < 2) {
                  const params = {
                    page_no: 1,
                    page_size: 10,
                  };
                  params.user_no = accountArr[0];
                  const basicInfo = await getStudentInfoList(params);
                  if (
                    basicInfo.code == 0 &&
                    basicInfo.data &&
                    basicInfo.data.list?.length > 0
                  ) {
                    setInputNickName(basicInfo.data.list[0].nick_name);
                  } else {
                    message.error("该学号不存在！");
                    return;
                  }
                } else {
                  setInputNickName("");
                }

                setShowComfirmModal(true);
              }}
              style={{ marginTop: 20 }}
              className="searchItem"
              type="primary"
            >
              确认提交
            </Button>
          </div>

          <Modal
            title="确认信息"
            open={showComfirmModal}
            // width={1000}
            onCancel={() => {
              setShowComfirmModal(false);
            }}
            footer={null}
          >
            <div style={{ padding: 40 }}>
              <div>
                {inputNickName
                  ? `学号：${accountStr.current} (${inputNickName})`
                  : `学号：${accountStr.current}`}
              </div>
              <div style={{ marginTop: 12 }}>
                {isAddSmartBeans ? (
                  <span>
                    在
                    <span>
                      <span
                        style={{ fontWeight: 500 }}
                      >{`${mainSelectedItem.current?.name}-${childSelectedItem.current.name}，`}</span>
                      担任
                      <span
                        style={{ fontWeight: 500 }}
                      >{`${roleSelectedItem.current.name}`}</span>
                      ，服务
                      <span
                        style={{ color: "red" }}
                      >{`${serverTimes.current}`}</span>
                      次，
                    </span>
                  </span>
                ) : (
                  <span>{`${accountStr.current}在${month.current}，因${reason.current},`}</span>
                )}
              </div>
              <div style={{ marginTop: 12 }}>
                {isAddSmartBeans ? `在此奖励` : `在此扣除`}
                <span style={{ color: "red" }}>{` ${beans.current} `}</span>
                智慧豆
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 40,
                }}
              >
                <Button onClick={onCommit} type="primary">
                  确定
                </Button>
              </div>
            </div>
          </Modal>
        </div>
      )}
      <Modal
        title="基础信息导入错误信息"
        open={showErrorModel}
        width={500}
        onCancel={() => {
          setShowErrorModel(false);
        }}
        footer={null}
      >
        <div
          style={{
            display: "flex",
            maxHeight: 500,
            overflow: "scroll",
            // alignItems: "center",
            // justifyContent: "center",
            flexDirection: "column",
            paddingTop: 30,
            paddingRight: 50,
            paddingLeft: 50,
          }}
        >
          {errorInfo.current.map((item) => {
            return (
              <div style={{ marginBottom: 10 }}>
                <span style={{ color: "red" }}>
                  {"第" + item.row_num + "行"}
                </span>
                {": " + item.reason + "\n"}
              </div>
            );
          })}
        </div>
      </Modal>
    </div>
  );
}
